import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  timeout: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

const defaultProps = {
  timeout: false,
  disabled: false
};

class StatusAdapter extends React.Component {
  constructor() {
    super();
    this.state = { error: false, success: false, fetching: false, touched: false };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setTouched = this.setTouched.bind(this);
  }

  async handleSubmit(...data) {
    const { submit, timeout, disabled } = this.props;
    if(disabled) return false;
    this.setState({ fetching: true, success: false, error: false });
    try {
      await submit(...data);
      this.setState({ fetching: false, success: true });
      if(timeout) {
        this.timeout = setTimeout(() => {
          this.setState({ success: false });
        }, 3000);
      }
    } catch (error) {
      this.setState({ fetching: false, error: error, success: false });
    }
  }

  setTouched() {
    this.setState({ touched: true });
  }

  render() {
    return (
      this.props.children(this.handleSubmit, { ...this.state, touched: this.context.forceTouched || this.state.touched, setTouched: this.setTouched })
    );
  }
}

StatusAdapter.defaultProps = defaultProps;
StatusAdapter.propTypes = propTypes;
StatusAdapter.contextTypes = {
  forceTouched: PropTypes.bool
};
export default StatusAdapter;

/* eslint-disable */
// use case: 
{/* <StatusAdapter submit={this.handleChangeAvatar} timeout={true}>
  {(submit, { error, success, fetching }) => ...}
</StatusAdapter>; */}


export class StatusAdapterGroup extends React.Component {
  state = { forceTouched: null };

  getChildContext() {
    const { forceTouched } = this.state;
    return {
      ...this.state
    };
  }

  setAllTouched = () => {
    this.setState({ forceTouched: true });
  }

  render() {
    return this.props.children({ setAllTouched: this.setAllTouched});
  }
}

StatusAdapterGroup.childContextTypes = {
  forceTouched: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/components/StatusAdapter.jsx